import React from 'react';

const NotFound = () => {
    return(
        <h1>דף לא נימצא</h1>
    );
};

export default NotFound;